"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorButtonDebug = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorButtonDebug = ({
  text
}) => {
  const navigate = (0, _react.useCallback)(() => {
    const url = new URL(window.location.href);

    // Add ?dbg (no value) if not already present
    if (!url.searchParams.has('dbg')) {
      url.searchParams.append('dbg', '');
    }
    const finalUrl = url.toString();
    if (window.self === window.top) {
      window.location.href = finalUrl;
    } else {
      window.parent.location.href = finalUrl;
    }
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
    sx: {
      justifyContent: 'center'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.StyledButton, {
      id: "ui-error-page-back-button",
      variant: "contained",
      color: "primary",
      onClick: navigate,
      children: text
    })
  });
};
exports.ErrorButtonDebug = ErrorButtonDebug;
